/**
 * Konstanten für Panel-bezogene Werte
 */
export const DEVICE_CONSTANTS = {
  // Offline-Erkennung
  OFFLINE_THRESHOLD_MINUTES: 5,
  
  // Helligkeit
  BRIGHTNESS_MAX: 255,
  BRIGHTNESS_MIN: 0,
  
  // Signal-Qualität Berechnung
  QUALITY_CALC_DIVISOR: 6,
  QUALITY_MIN: 1,
  QUALITY_MAX: 30,
  
  // API Timeouts
  TIMEOUT_MS: 10000,
  
  // Sonnen-Icon
  SUN_RAYS_COUNT: 8,
  SUN_RAY_MIN_LENGTH: 4,
  SUN_RAY_MAX_LENGTH: 12,
  SUN_CENTER_RADIUS: 8,
  SUN_CIRCLE_RADIUS: 6
};

export const ONLINE_THRESHOLD_MS = DEVICE_CONSTANTS.OFFLINE_THRESHOLD_MINUTES * 60 * 1000;

/**
 * Feld-Mapping für Panel-Werte
 * t – Temperatur
 * h – Luftfeuchtigkeit
 * s – Signal-Qualität
 * g – Gas-Widerstand
 * r – Timestamp
 */
export const DEVICE_VALUE_FIELDS = {
  TEMPERATURE: 'value_t',
  HUMIDITY: 'value_h',
  SIGNAL_QUALITY: 'value_s',
  GAS_RESISTANCE: 'value_g',
  TIMESTAMP: 'value_r',
  CREATED: 'value_created'
};
